<template>
  <div>
    <md-card-content>
      <md-table class="paginated-table table-striped table-hover">
        <md-table-head>ID</md-table-head>
        <md-table-head>{{ $t("Name") }}</md-table-head>
        <md-table-head>{{ $t("Edit") }}</md-table-head>
        <md-table-toolbar style="padding: 0 0 20px 0;">
          <md-field>
            <md-button
              class="md-raised md-primary"
              @click="showProjectEditor(-1)"
            >
              {{ $t("Add") }}
            </md-button>
          </md-field>
        </md-table-toolbar>
        <md-table-row v-for="(item, position) in projects" :key="position">
          <md-table-cell md-label="ID">{{ position + 1 }}</md-table-cell>
          <md-table-cell :md-label="$t('Name')">
            {{ item.name }}
          </md-table-cell>
          <md-table-cell>
            <md-button
              class="md-just-icon md-simple md-primary"
              @click="showProjectEditor(position)"
            >
              <md-icon>create</md-icon>
            </md-button>
          </md-table-cell>
          <template v-if="item.livestreaming">
            <md-table-cell>
              <md-button
                class="md-just-icon md-simple md-primary"
                @click="manageLivestream(item.name)"
              >
                <md-icon>play_arrow</md-icon>
                <md-tooltip md-direction="top">Start Livestream</md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell>
              <md-button
                class="md-just-icon md-simple md-primary"
                @click="viewLivestream(item.name)"
              >
                <md-icon>desktop_mac</md-icon>
                <md-tooltip md-direction="top">View Livestream</md-tooltip>
              </md-button>
            </md-table-cell>
          </template>
        </md-table-row>
      </md-table>
    </md-card-content>
    <Toast ref="toast" />
  </div>
</template>

<script>
import Toast from "@/components/Toast.vue";
import { EventBus } from "@/helpers";

export default {
  props: {
    projects: {
      type: Array,
      required: true
    }
  },
  components: {
    Toast
  },
  mounted() {
    EventBus.$on("showLivestreamToast", this.handleShowToast);
  },
  beforeDestroy() {
    EventBus.$off("showLivestreamToast", this.handleShowToast);
  },
  methods: {
    showProjectEditor(position) {
      this.$emit("showProjectEditor", position);
    },
    manageLivestream(projectName) {
      this.$store.dispatch("setting/manageLiveStream", {
        projectName: projectName
      });
    },
    viewLivestream(projectName) {
      window.location.href = `https://livestream.rpaswilco.com?roomName=${projectName}`;
    },
    handleShowToast(message) {
      this.$refs.toast.showToast(message);
    }
  }
};
</script>
